import requests from "./httpService";

const BrandServices = {
  createBrand(brandData) {
    return requests.post("/api/brands", brandData);
  },

  getAllBrands() {
    return requests.get("/api/brands");
  },

  getBrandById(id) {
    return requests.get(`/api/brands/${id}`);
  },

  updateBrand(id, brandData) {
    return requests.put(`/api/brands/${id}`, brandData);
  },

  deleteBrand(id) {
    return requests.delete(`/api/brands/${id}`);
  }
};

export default BrandServices;